import { render, staticRenderFns } from "./RecurringSMSCampaignInfoRoute.vue?vue&type=template&id=f4537258&scoped=true&"
import script from "./RecurringSMSCampaignInfoRoute.vue?vue&type=script&lang=js&"
export * from "./RecurringSMSCampaignInfoRoute.vue?vue&type=script&lang=js&"
import style0 from "./RecurringSMSCampaignInfoRoute.vue?vue&type=style&index=0&id=f4537258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4537258",
  null
  
)

export default component.exports